import React from "react";
import styled from "styled-components";

const ProjectDescriptionElement = styled.p`
  margin-bottom: var(--spacing-large);
  font-size: var(--font-size-text-small);

  @media (min-width: 768px) {
    padding: var(--spacing-clear) var(--spacing-medium);
  }
`;

const ProjectDescription = ({ className, style, children }) => {
  return (
    <ProjectDescriptionElement className={className} style={style}>
      {children}
    </ProjectDescriptionElement>
  );
};

export default ProjectDescription;
